export const routes = {
  audit: {
    index: '/audits',
    details: '/:auditId',
  },

  userProfile: {
    index: '/user-profile',
  },

  userSettings: {
    index: '/user-settings',
  },
};
